import { Value } from '../../types';
import { HttpMethod, HttpStatus, RequestOptions } from '../http-service';

import { EventsRequest } from './default-file-handler';

export interface FileHandler {
  download: (endpoint: string, name?: string, parameters?: Record<string, Value>, method?: HttpMethod, options?: RequestOptions) => Promise<Blob>;
  preview: (path: string) => void;
  remove: (path: string, name: string, onExecuteRemove: RemoveCallback) => void;
  setConfiguration: (fileHandlerConfiguration: FileHandlerConfiguration) => void;
  upload: (file: File, events: EventsRequest) => Promise<FileInterface>;
}

export default class FileHandlerConfiguration {
  previewUrl = '';
  removeResponseState = HttpStatus.OK;
  removeUrl = '';
  uploadResponseState = HttpStatus.CREATED;
  uploadUrl = '';
}

export interface FileInterface {
  onCancel?: Function;
  uploadProgress: Record<string, any>;
}

export type RemoveCallback = (name: string, path: string, status: number, removed: boolean) => void;
